import { useCallback } from "react";

import { useFastshiftAnalyticsData, useFireAnalyticsEvents } from "@/analytics";
import {
    ActionKey,
    ActionSubjectKey,
    ActionSubjectIdKey
} from "@/analytics/constants";

export const useFeedbackCollectorAnalytics = () => {
    const { sourceKey, identityAttrs } = useFastshiftAnalyticsData(true);
    const { fireUIEvent } = useFireAnalyticsEvents(identityAttrs);

    const sendFeedbackCollectorOpenButtonClickUIEvent = useCallback(() => {
        fireUIEvent({
            action: ActionKey.CLICKED,
            actionSubject: ActionSubjectKey.BUTTON,
            actionSubjectId: ActionSubjectIdKey.FEEDBACK_COLLECTOR_OPEN_BUTTON,
            source: sourceKey
        });
    }, [fireUIEvent, sourceKey]);

    const sendFeedbackCollectorSubmitButtonClickUIEvent = useCallback(
        (feedbackType: string) => {
            fireUIEvent({
                action: ActionKey.CLICKED,
                actionSubject: ActionSubjectKey.BUTTON,
                actionSubjectId:
                    ActionSubjectIdKey.FEEDBACK_COLLECTOR_SUBMIT_BUTTON,
                source: sourceKey,
                attributes: {
                    feedbackType
                }
            });
        },
        [fireUIEvent, sourceKey]
    );

    return {
        sendFeedbackCollectorOpenButtonClickUIEvent,
        sendFeedbackCollectorSubmitButtonClickUIEvent
    };
};
